<template>
  <div class="d-flex flex-column" style="height: 100%; overflow-x: hidden;">
    <slot name="header"></slot>

    <div class="flex-grow-1" ref="scrollable" style="overflow-y: hidden">
      <slot />
    </div>

    <v-pagination v-model="page" color="grey lighten-1" class="mt-1" :length="pages" />
  </div>
</template>

<script>

export default {
  name: 'DynamicallyPaginated',

  props: {
    itemCount: {
      type: Number,
      default: 0,
    },

    rowHeight: {
      type: Number,
      required: true,
    },
  },

  data: () => ({
    page: 1,
    pageSize: 0,
    resizeObserver: null,
  }),

  computed: {
    pages() {
      return this.pageSize == 0 ? 0 : Math.ceil(this.itemCount / this.pageSize)
    },

    currentPageRewards() {
      return this.allRewards.data
    },
  },

  watch: {
    page() { this.reload() },
  },

  methods: {
    reload() {
      if (this.pageSize > 0 ) {
        this.$emit('reload', { 
          limit: this.pageSize,
          offset: (this.page-1) * this.pageSize,
        })
      }
    }
  },

  async mounted() {
    const { rowHeight } = this

    this.pageSize = Math.floor(this.$refs.scrollable.offsetHeight / rowHeight)
    this.reload()

    this.resizeObserver = new ResizeObserver(entries => {
      this.pageSize = Math.floor(entries[0].contentRect.height / rowHeight)
      this.reload()
    })

    this.resizeObserver.observe(this.$refs.scrollable)
  },

  beforeUnmount() {
    this.resizeObserver.unobserve(this.$refs.scrollable)
  }
}


</script>
